// api/payments.js
import apiConfig from './api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

const authHeader = () => {
  const token = sessionStorage.getItem('authToken');
  if (!token) throw new Error('Authentication token is missing');
  return { 'Authorization': `Bearer ${token}` };
};

export const createLink = async (userId, plan_id, quantity) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) throw new Error('Authentication token is missing');

    const response = await fetch(
      `${api_base_url}/api/${api_key}/payments/post/${userId}/subscriptions/createSubsLink`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ plan_id, quantity }),
      }
    );

    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(`Server responded with ${response.status}: ${errorData}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating link:', error);
    throw error;
  }
};

export const getSubsRzp = async (userId, sub_id) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) throw new Error('Authentication token is missing');

    console.log('sub_id', sub_id);
    const url = `${api_base_url}/api/${api_key}/payments/get/${userId}/subscriptions/subsRzp?sub_id=${encodeURIComponent(sub_id)}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting subscription:', error);
    throw error;
  }
};

export const getSubs = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) throw new Error('Authentication token is missing');

    const url = `${api_base_url}/api/${api_key}/payments/get/${userId}/subscriptions/subs`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const txt = await response.text();
      throw new Error(`Server responded ${response.status}: ${txt}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting subscription:', error);
    throw error;
  }
};

export const getInvoiceById = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) throw new Error('Authentication token is missing');

    const url = `${api_base_url}/api/${api_key}/payments/get/${userId}/subscriptions/invoiceById`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const txt = await response.text();
      throw new Error(`Server responded ${response.status}: ${txt}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting invoice by customer id:', error);
    throw error;
  }
};

export const getInvoicePdf = async (userId, invoice_id) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) throw new Error("Missing token");

    const url = `${api_base_url}/api/${api_key}/payments/get/${userId}/subscriptions/invoicePdf?invoice_id=${invoice_id}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    // PDF is a file, so return blob
    const blob = await response.blob();

    return blob;          
  } catch (err) {
    console.error("Fetch Invoice PDF Error:", err);
    throw err;
  }
};

export const getInvoiceHtml = async (userId, invoice_id) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) throw new Error("Missing token");

    const url = `${api_base_url}/api/${api_key}/payments/get/${userId}/subscriptions/invoiceHtml?invoice_id=${invoice_id}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const htmlContent = await response.text();
    return htmlContent;          
  } catch (err) {
    console.error("Fetch Invoice HTML Error:", err);
    throw err;
  }
};

export const getPlans = async () => {
  try {
    const url = `${api_base_url}/api/${api_key}/payments/get/subscriptions/plans`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const txt = await response.text();
      throw new Error(`Server responded ${response.status}: ${txt}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching plans:', error);
    throw error;
  }
};
